import api from '../../../api/apibackend'
import Nprogress from 'nprogress'
import Vue from 'vue'

import { GET_ACCOUNTS, CREATE_ACCOUNT, UPDATE_ACCOUNT, DELETE_ACCOUNT } from "./actionTypes";
import { GET_ACCOUNTS_SUCCESS, CREATE_ACCOUNT_SUCCESS, UPDATE_ACCOUNT_SUCCESS, SET_LOADER, DELETE_ACCOUNT_SUCCESS } from "./mutationTypes"
import { changeBodyToForm } from "../../../utils";

const state = {
    ids: [],
    accounts: {},
    isLoading: false
}

const getters = {
    accounts: state => Object.keys(state.accounts).map(id => state.accounts[id])
}

const mutations = {
    [GET_ACCOUNTS_SUCCESS](state, { ids, data }) {
        state.ids = ids
        state.accounts = {
            ...state.accounts,
            ...data
        }
    },
    [CREATE_ACCOUNT_SUCCESS](state, { data: account }) {
        state.accounts = {
            ...state.accounts,
            [account.id]: account
        }
    },
    [UPDATE_ACCOUNT_SUCCESS](state, { data: account }) {
        state.accounts = { ...state.accounts, [account.id]: account }
    },
    [SET_LOADER](state, value) {
        state.isLoading = value
    },
    [DELETE_ACCOUNT_SUCCESS](state, id) {
        Vue.delete(state.accounts, id)
    }
}

const actions = {
    async [GET_ACCOUNTS]({ commit }) {
        Nprogress.start();
        try {
            const { data } = await api.get("ticket/ticket-accounts")
            commit(GET_ACCOUNTS_SUCCESS, data)
        } catch (err) {
            somethingWentWrong(err)
        }
        Nprogress.done();
    },
    async [CREATE_ACCOUNT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();
        try {
            const { data } = await api.post("ticket/ticket-accounts", changeBodyToForm(payload.account), {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            commit(CREATE_ACCOUNT_SUCCESS, data)
            if (payload.close) {
                payload.close()
            }
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    },
    async [UPDATE_ACCOUNT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();
        try {
            const { data } = await api.put(`ticket/ticket-accounts/${payload.id}`, payload.account)
            commit(UPDATE_ACCOUNT_SUCCESS, data)
            if (payload.close) {
                payload.close()
            }
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ ${data.message}`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    },
    async [DELETE_ACCOUNT]({ commit, state }, payload) {
        if (state.isLoading) return
        commit(SET_LOADER, true)
        Nprogress.start();

        try {
            const { data } = await api.delete(`ticket/ticket-accounts/${payload.id}`)
            commit(DELETE_ACCOUNT_SUCCESS, payload.id)
            if (payload.close) {
                payload.close()
            }
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: `✔️ Delete Successfully`
            })
        } catch (err) {
            somethingWentWrong(err)
        }
        commit(SET_LOADER, false)
        Nprogress.done();
    }
}
const somethingWentWrong = (err) => {
    console.log(err)
    Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: err.message
    })
}

export default {
    state,
    getters,
    mutations,
    actions
}
